import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EndpointCardComponent } from './endpoint-card.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';



@NgModule({
  declarations: [
    EndpointCardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule,
  ],
  exports: [
    EndpointCardComponent
  ]
})
export class EndpointCardModule { }
